import React from 'react';
import {Link} from 'react-router';
import PropTypes from 'prop-types';

import styles from './LinkButton.scss';
import Button from 'components/controls/buttons/Button';
import SimpleButton from 'components/controls/buttons/SimpleButton';

const preventDefault = (e) => {
    e.preventDefault();
    e.stopPropagation();
}

export default function LinkButton({
    to,
    disabled,
    isExternal,
    ...restProps
}) {

    if (disabled) {
        // Wrap to prevent click event on element-wrapper
        return (
            <SimpleButton
                onClick={preventDefault}
                className={styles.button}
            >
                <Button
                    disabled={disabled}
                    {...restProps}
                />
            </SimpleButton>
        )
    }

    return isExternal ? (
       <a
        href={to}
        className={styles.link}
       >
           <Button
               disabled={disabled}
               {...restProps}
           />
       </a>
    ) : (
        <Link
            to={to}
            className={styles.link}
        >
            <Button
                disabled={disabled}
                {...restProps}
            />
        </Link>
    )
}

LinkButton.propTypes = {
    to: PropTypes.string,
};

LinkButton.defaultProps = {
    to: '/',
};



// WEBPACK FOOTER //
// ./src/components/controls/buttons/LinkButton.jsx